var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 1.16395C9.56162 0.753097 10.4384 0.753097 11.15 1.16395L18.8093 5.58605C19.5209 5.9969 19.9593 6.7562 19.9593 7.57791V16.4221C19.9593 17.2438 19.5209 18.0031 18.8093 18.414L11.15 22.836C10.4384 23.2469 9.56162 23.2469 8.85 22.836L1.19071 18.414C0.479085 18.0031 0.0407076 17.2438 0.0407076 16.4221V7.57791C0.0407076 6.75619 0.479085 5.9969 1.19071 5.58605L8.85 1.16395Z",
    fill: "#21B8CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09961 1.59668C9.62162 1.29529 10.2577 1.27643 10.7939 1.54004L10.9004 1.59668L18.5596 6.01953C19.1162 6.34113 19.459 6.93521 19.459 7.57812V16.4219C19.459 17.0249 19.1579 17.5854 18.6611 17.918L18.5596 17.9805L10.9004 22.4033C10.3784 22.7047 9.7423 22.7236 9.20605 22.46L9.09961 22.4033L1.44043 17.9805C0.883751 17.6589 0.541016 17.0648 0.541016 16.4219V7.57812C0.541016 6.97514 0.842142 6.41459 1.33887 6.08203L1.44043 6.01953L9.09961 1.59668Z",
    stroke: "black",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.554c4033383f920b453bab76a656e555.svg";
export { ForwardRef as ReactComponent };